export function getWidth(value: number, viewport: number): boolean {
  return value > viewport;
}
